<template>
  <div class="channel">
    <PageWrapperComponent>
      <BoxComponent :mb="48">
        <FlexComponent justify="flex-end">
          <Datepicker :date-range="dataDateRange" :on-update="updateDataDateRange" :show-all-time-shortcut="true" />
        </FlexComponent>
      </BoxComponent>
      <div class="row">
        <loading-spinner v-if="!isFlagsReady" :size="64" :is-global="false" />
        <div v-else class="col-12">
          <nav>
            <div id="nav-tab" class="nav nav-tabs" role="tablist">
              <button
                id="nav-home-tab"
                class="nav-link active"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
              >
                Creators
              </button>
              <button
                id="nav-profile-tab"
                class="nav-link"
                data-bs-toggle="tab"
                data-bs-target="#nav-profile"
                type="button"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false"
              >
                Links
              </button>
            </div>
          </nav>
          <div id="nav-tabContent" class="tab-content box-shadow">
            <div id="nav-home" class="tab-pane fade show active" role="tabpanel" aria-labelledby="nav-home-tab" tabindex="0">
              <InfluencersTable />
            </div>
            <div id="nav-profile" class="tab-pane fade" role="tabpanel" aria-labelledby="nav-profile-tab" tabindex="0">
              <LinksTable />
            </div>
          </div>
        </div>
      </div>
    </PageWrapperComponent>
  </div>
</template>

<script lang="ts">
import { PageWrapperComponent } from '@metapic-apps/shared'
import { useFlagsStatus } from '@unleash/proxy-client-vue'
import { mapGetters } from 'vuex'

import InfluencersTable from '@/components/channel/InfluencersTable.vue'
import LinksTable from '@/components/channel/LinksTable.vue'
import Datepicker from '@/components/Datepicker.vue'
import BoxComponent from '@/ui-library/atoms/BoxComponent/BoxComponent.vue'
import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'

export default {
  name: 'Channel',
  components: {
    BoxComponent,
    FlexComponent,
    Datepicker,
    PageWrapperComponent,
    InfluencersTable,
    LinksTable,
  },
  middleware: 'auth',
  data() {
    return {
      isFlagsReady: useFlagsStatus().flagsReady,
    }
  },
  computed: {
    ...mapGetters('user', ['user', 'dataDateRange']),
  },
  created() {
    this.$store.dispatch('trafficSources/fetchTrafficSources')
  },
  methods: {
    updateDataDateRange(range) {
      this.$store.dispatch('user/updateDataDateRange', range)
    },
  },
}
</script>

<style lang="scss" scoped>
.box-shadow {
  -webkit-box-shadow: 0 5px 35px 0 rgba(154, 161, 171, 0.3);
  box-shadow: 0 5px 35px 0 rgba(154, 161, 171, 0.3);
}

.sort-icon {
  margin-left: 4px;
}

.nav-tabs {
  button {
    background: #fff;
    border: 0;
    border-radius: 0;
    color: #9ba3b7;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin-right: 5px;
    padding: 16px 48px;
    text-transform: uppercase;
    transition: opacity 0.3s;
    @include media-breakpoint-down(md) {
      font-size: 14px;
      padding: 16px 39px 14px;
    }

    &.active {
      border-top: 1px solid var(--primary);
      color: var(--primary);
    }

    &:not(.active) {
      box-shadow: 0 5px 60px rgba(0, 0, 0, 0.1);
      opacity: 0.4;
    }

    &:hover {
      opacity: 0.8;
    }
  }
}

.tab-content {
  padding: 32px;
  @include media-breakpoint-down(md) {
    padding: 15px;
  }
}
</style>
